import * as ambassadorWixSocialGroupsV2GroupMember from './social-groups-v2-group-member-members.http.js';
import * as ambassadorWixSocialGroupsV2GroupMemberTypes from './social-groups-v2-group-member-members.types.js';
import * as ambassadorWixSocialGroupsV2GroupMemberUniversalTypes from './social-groups-v2-group-member-members.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function addGroupMembers(): __PublicMethodMetaInfo<
  'POST',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.AddGroupMembersRequest,
  ambassadorWixSocialGroupsV2GroupMemberTypes.AddGroupMembersRequest,
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.AddGroupMembersResponse,
  ambassadorWixSocialGroupsV2GroupMemberTypes.AddGroupMembersResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupMember.addGroupMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups/{groupId}/members',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeGroupMembers(): __PublicMethodMetaInfo<
  'DELETE',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.RemoveGroupMembersRequest,
  ambassadorWixSocialGroupsV2GroupMemberTypes.RemoveGroupMembersRequest,
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.RemoveGroupMembersResponse,
  ambassadorWixSocialGroupsV2GroupMemberTypes.RemoveGroupMembersResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupMember.removeGroupMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/groups/{groupId}/members',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listGroupMembers(): __PublicMethodMetaInfo<
  'GET',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.ListGroupMembersRequest,
  ambassadorWixSocialGroupsV2GroupMemberTypes.ListGroupMembersRequest,
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.ListGroupMembersResponse,
  ambassadorWixSocialGroupsV2GroupMemberTypes.ListGroupMembersResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupMember.listGroupMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/groups/{groupId}/members',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryGroupMembers(): __PublicMethodMetaInfo<
  'POST',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.QueryGroupMembersRequest,
  ambassadorWixSocialGroupsV2GroupMemberTypes.QueryGroupMembersRequest,
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.QueryGroupMembersResponse,
  ambassadorWixSocialGroupsV2GroupMemberTypes.QueryGroupMembersResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupMember.queryGroupMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups/{groupId}/members/query',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMemberships(): __PublicMethodMetaInfo<
  'GET',
  { memberId: string },
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.ListMembershipsRequest,
  ambassadorWixSocialGroupsV2GroupMemberTypes.ListMembershipsRequest,
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.ListMembershipsResponse,
  ambassadorWixSocialGroupsV2GroupMemberTypes.ListMembershipsResponse
> {
  const payload = { memberId: ':memberId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupMember.listMemberships(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/members/{memberId}/memberships',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryMemberships(): __PublicMethodMetaInfo<
  'POST',
  { memberId: string },
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.QueryMembershipsRequest,
  ambassadorWixSocialGroupsV2GroupMemberTypes.QueryMembershipsRequest,
  ambassadorWixSocialGroupsV2GroupMemberUniversalTypes.QueryMembershipsResponse,
  ambassadorWixSocialGroupsV2GroupMemberTypes.QueryMembershipsResponse
> {
  const payload = { memberId: ':memberId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupMember.queryMemberships(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/members/{memberId}/memberships/query',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  GroupMember as GroupMemberOriginal,
  GroupRole as GroupRoleOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  SocialGroupsEvent as SocialGroupsEventOriginal,
  SocialGroupsEventPayloadOneOf as SocialGroupsEventPayloadOneOfOriginal,
  MemberJoinedGroup as MemberJoinedGroupOriginal,
  MembersAddedToGroup as MembersAddedToGroupOriginal,
  JoinRequestsApproved as JoinRequestsApprovedOriginal,
  MembersInvitedToGroup as MembersInvitedToGroupOriginal,
  JoinRequest as JoinRequestOriginal,
  MembershipQuestionAnswer as MembershipQuestionAnswerOriginal,
  JoinResponse as JoinResponseOriginal,
  MemberJoined as MemberJoinedOriginal,
  JoinBy as JoinByOriginal,
  JoinByWithLiterals as JoinByWithLiteralsOriginal,
  LeaveRequest as LeaveRequestOriginal,
  LeaveResponse as LeaveResponseOriginal,
  MemberLeft as MemberLeftOriginal,
  AddGroupMembersRequest as AddGroupMembersRequestOriginal,
  AddGroupMembersResponse as AddGroupMembersResponseOriginal,
  MemberAdded as MemberAddedOriginal,
  RemoveGroupMembersRequest as RemoveGroupMembersRequestOriginal,
  RemoveGroupMembersResponse as RemoveGroupMembersResponseOriginal,
  MemberRemoved as MemberRemovedOriginal,
  ListGroupMembersRequest as ListGroupMembersRequestOriginal,
  ListGroupMembersResponse as ListGroupMembersResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  QueryGroupMembersRequest as QueryGroupMembersRequestOriginal,
  Query as QueryOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryGroupMembersResponse as QueryGroupMembersResponseOriginal,
  QueryNonGroupMembersRequest as QueryNonGroupMembersRequestOriginal,
  QueryNonGroupMembersResponse as QueryNonGroupMembersResponseOriginal,
  ListMembershipsRequest as ListMembershipsRequestOriginal,
  ListMembershipsResponse as ListMembershipsResponseOriginal,
  Membership as MembershipOriginal,
  MembershipStatus as MembershipStatusOriginal,
  MembershipStatusWithLiterals as MembershipStatusWithLiteralsOriginal,
  QueryMembershipsRequest as QueryMembershipsRequestOriginal,
  QueryMembershipsResponse as QueryMembershipsResponseOriginal,
  QueryMyMembershipRequest as QueryMyMembershipRequestOriginal,
  QueryMyMembershipResponse as QueryMyMembershipResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './social-groups-v2-group-member-members.types.js';
